import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { SESSION_TOKEN_KEY } from "@babackapp/private-api-client/client/use-session-token";

async function getPresignedUrl(
  file: File,
): Promise<{ url: string; s3Key: string }> {
  const { data, response } = await fetchClient.POST(
    "/public/return-request/image/presigned-url",
    {
      body: { fileName: file.name, contentType: file.type } as any,
      params: {
        header: {
          authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}`,
        },
      },
    },
  );
  if (!response.ok) throw new Error("Failed to get presigned URL");
  return data as { url: string; s3Key: string };
}

async function uploadToS3(presignedUrl: string, file: File): Promise<void> {
  const response = await fetch(presignedUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });
  if (!response.ok) throw new Error("S3 upload failed");
}

async function confirmUpload(s3Key: string): Promise<string> {
  const { data, response } = await fetchClient.POST(
    "/public/return-request/image/confirm",
    {
      body: { key: s3Key } as any,
      params: {
        header: {
          authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}`,
        },
      },
    },
  );
  if (!response.ok) throw new Error("Failed to confirm upload");
  return (data as any).url as string;
}

export function useUploadImage() {
  return useMutation({
    mutationFn: async (file: File): Promise<string> => {
      const { url: presignedUrl, s3Key } = await getPresignedUrl(file);
      await uploadToS3(presignedUrl, file);
      return confirmUpload(s3Key);
    },
  });
}
